export default {
  info: null,
  singles: [],
  albums: []
};
